import { assignProps, compareByName } from '@/utils/resultsHelper';
import { responseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import actions from '../constants';
import { findDatasetMetrics } from './state';

const fetchDatasetMetrics = withDraft((draft, action) => {
  const item = findDatasetMetrics(draft, action);

  if (item) {
    item.readStatus = states.PENDING;
    item.readErrors = [];
  } else {
    draft.datasetMetrics[action.category].results.push({
      code: action.code,
      readStatus: states.PENDING,
      readErrors: [],
    });
  }
});

const fetchDatasetMetricsSuccess = withDraft((draft, action) => {
  const item = findDatasetMetrics(draft, action);
  action.result.dictionaries.sort(compareByName);
  assignProps(item, {
    ...action.result,
    readStatus: states.SUCCESS,
    readErrors: [],
  });
});

const fetchDatasetMetricsError = withDraft((draft, action) => {
  const item = findDatasetMetrics(draft, action);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

export default {
  [actions.FETCH_DATASET_METRICS]: fetchDatasetMetrics,
  [actions.FETCH_DATASET_METRICS_ERROR]: fetchDatasetMetricsError,
  [actions.FETCH_DATASET_METRICS_SUCCESS]: fetchDatasetMetricsSuccess,
};
